// extracted by mini-css-extract-plugin
export default {"collapseItem":"Collapse_collapseItem__rkzW8","collapseHeader":"Collapse_collapseHeader__YRxwR"};